import Dialog from "~/ui/dialog";
import { node } from "~/util/dom";

export default class LoaderDialog {
	_dialog: Dialog;

	constructor() {
		this._dialog = new Dialog({
			className: "loader-dialog",
			bgClose: false,
			onClose: data => {
				// preskocime esc
				if (data.isEsc) {
					return;
				}
				this._dialog.close();
			},
		});
		const content = this._dialog.dom.content;
		const loaderImg = node("img");

		loaderImg.src = "/img/loader.gif";
		content.appendChild(loaderImg);
		this._dialog.open();
	}

	close() {
		this._dialog.close();
	}
}
